import { useEffect } from 'react'
import { scrollToTop } from '../../global/helpers'

/**
 * Scroll to top if eny of props changes
 * @param  {...any} props
 */
const useScrollToTop = (...props) => {
    useEffect(() => {
        scrollToTop()
    }, [props])
}

export default useScrollToTop
